import styled from "styled-components";
import {
  ORDER_TYPE_TO_DISPLAY,
  STOP_MARKET_ORDER_TYPE,
} from "common/constants";
import { LanguageNameSpaces, OrderType } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";

interface OrderTypeSelectorProps {
  selectedOrderType: string;
  showStopMarket?: boolean;
  handleSelectOrderType: (orderType: OrderType) => void;
}

const OrderTypeSelector = ({
  selectedOrderType,
  showStopMarket,
  handleSelectOrderType,
}: OrderTypeSelectorProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  let orderTypes = Object.keys(ORDER_TYPE_TO_DISPLAY) as OrderType[];
  if (!showStopMarket) {
    orderTypes = orderTypes.filter(
      (orderType) => orderType !== STOP_MARKET_ORDER_TYPE
    );
  }

  return (
    <Background>
      {orderTypes.map((orderType) => (
        <OrderTypeItem
          $selected={selectedOrderType === orderType}
          onClick={() => handleSelectOrderType(orderType)}
          key={orderType}
        >
          {t(ORDER_TYPE_TO_DISPLAY[orderType])}
        </OrderTypeItem>
      ))}
    </Background>
  );
};

export default OrderTypeSelector;

const Background = styled.div`
  background: ${(p) => p.theme.colors.titleCardBgColor};
  border-radius: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px;
`;

const OrderTypeItem = styled.div<{ $selected?: boolean }>`
  flex: 1 1 0;
  white-space: nowrap;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  cursor: pointer;
  color: ${(p) => p.theme.colors.textColor};
  ${(props) =>
    props.$selected &&
    `
    background: ${props.theme.colors.cardBgColor};
    border-radius: 7px;
    box-shadow: 0px 6px 24px rgba(46, 73, 92, 0.123306);
  `}
`;
